import React from 'react';
import { Card, Avatar, Typography, List, Row, Col, Button } from 'antd';
import {
  UserOutlined, MailOutlined, IdcardOutlined, HomeOutlined,
  EnvironmentOutlined, CompassOutlined, TagOutlined, CopyOutlined, ArrowLeftOutlined
} from '@ant-design/icons';

const { Title, Text } = Typography;

const MinimalListItem = ({ icon, label, value, copyable }) => (
  <List.Item
    style={{
      padding: '8px 0',
      borderBottom: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    }}
  >
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <span style={{ marginRight: 10 }}>{icon}</span>
      <Text style={{ fontWeight: 500 }}>{label}:</Text>
    </div>
    <div>
      <Text type="secondary" style={{ fontSize: 14 }}>{value}</Text>
      {copyable && (
        <Button
          icon={<CopyOutlined />}
          size="small"
          style={{ marginLeft: 8, border: 'none', background: 'transparent' }}
          onClick={() => navigator.clipboard.writeText(value)}
        />
      )}
    </div>
  </List.Item>
);

const MyProfilePage = ({ user, onBack }) => {
  const {
    name = 'Ruchi Kwatra',
    username = '@olyam',
    birthday = '10/23/1985',
    gender = 'Female',
    email = 'olyayackovleva@gmail.com',
    address = 'Level 4, 403/227 Collins Street',
    suburb = 'Melbourne',
    state = 'Victoria',
    postcode = '3000',
    payId = '430710027rk@cahswo.com.au'
  } = user || {};

  const fields = [
    { icon: <IdcardOutlined />, label: 'Birthday', value: birthday },
    { icon: <MailOutlined />, label: 'Email', value: email },
    { icon: <HomeOutlined />, label: 'Address', value: address },
    { icon: <EnvironmentOutlined />, label: 'Suburb', value: suburb },
    { icon: <CompassOutlined />, label: 'State', value: state },
    { icon: <TagOutlined />, label: 'Post code', value: postcode },
    { icon: <UserOutlined />, label: 'Gender', value: gender },
    { icon: <IdcardOutlined />, label: 'Pay ID', value: payId, copyable: true },
  ];

  return (
    <Row justify="center" style={{ padding: '24px', background: '#f5f7fa', minHeight: '100vh' }}>
      <Col xs={24} sm={16} md={12} lg={8} xl={6}>
        {/* Back Arrow Header */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16, marginLeft: 8 }}>
          <Button
            type="text"
            icon={<ArrowLeftOutlined style={{ fontSize: 22 }} />}
            onClick={onBack}   // 🔹 use parent onBack instead of navigate(-1)
            style={{ boxShadow: 'none', padding: 0, marginRight: 8 }}
            aria-label="Back"
          />
          <Title level={5} style={{ margin: 0, flex: 1 }}>Profile</Title>
        </div>
        <Card
          style={{
            borderRadius: 16,
            boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
            padding: 0,
            background: '#fff'
          }}
          cover={
            <Avatar
              size={80}
              style={{ background: "#1890ff", margin: "24px auto" }}
              icon={<UserOutlined />}
            />
          }
        >
          <Title level={4} style={{ textAlign: 'center', marginBottom: 0 }}>
            {name}
          </Title>
          <Text type="secondary" style={{ display: 'block', textAlign: 'center', marginBottom: 24 }}>
            {username}
          </Text>
          <List
            itemLayout="horizontal"
            dataSource={fields}
            renderItem={item => (
              <MinimalListItem key={item.label} {...item} />
            )}
            style={{ margin: '0' }}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default MyProfilePage;
